import { motion } from "framer-motion";
import { Bike, ChefHat, Sparkles, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: Bike, title: "28-min delivery", body: "Hyper-local riders & smart routing get your order hot, fast." },
  { icon: ChefHat, title: "8,400+ kitchens", body: "From hidden street stalls to top-rated restaurants — all in one app." },
  { icon: Sparkles, title: "Curated for you", body: "Personalised picks based on your taste, time of day, and weather." },
  { icon: ShieldCheck, title: "Safe & hygienic", body: "FSSAI-verified partners, sealed packaging and contactless delivery." },
];

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-white py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-[#65A30D] font-bold">About FUDK</div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-3 text-ink-900"
            >
              Built in Bangalore. <br />
              <span className="text-[#84CC16]">Made for foodies.</span>
            </motion.h2>
            <p className="mt-6 text-base md:text-lg text-neutral-700 leading-relaxed max-w-xl">
              FUDK started as a tiny experiment in Basavanagudi — a few friends, a love for filter coffee, and a
              question: <em>why does great food take so long to find?</em> Today FUDK is a delivery network connecting
              hungry humans with the kitchens they love.
            </p>
            <a
              href="/restaurants"
              data-testid="about-explore-btn"
              className="mt-8 inline-flex items-center bg-ink-900 text-white font-semibold rounded-full px-6 py-3 hover:bg-[#262626] transition-colors"
            >
              Explore Restaurants
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {FEATURES.map((f, i) => (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="bg-neutral-50 border border-neutral-200 rounded-2xl p-6 hover:-translate-y-1 hover:border-[#84CC16] transition-all"
                data-testid={`about-feature-${i}`}
              >
                <f.icon className="text-[#65A30D]" size={28} />
                <div className="font-display font-bold text-xl mt-4 text-ink-900">{f.title}</div>
                <p className="text-sm text-neutral-600 mt-2 leading-relaxed">{f.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
